import { useEffect, useState } from 'react';

export const useHasScrolledPastThreshold = (threshold) => {
  const [show, setShow] = useState(() => window.scrollY > threshold);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledPastThreshold = window.scrollY > threshold;
      setShow((prev) => (prev === scrolledPastThreshold ? prev : scrolledPastThreshold));
    };

    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return { showBasedOnScroll: show };
};
